import { combineReducers } from "redux";
import UploadFileReducer from "./uploadFileReducer";
const rootReducer = combineReducers({
  UploadFileReducer,
});

export default rootReducer;
